import { render, staticRenderFns } from "./basicConfig.vue?vue&type=template&id=a60b5cf4&scoped=true&"
import script from "./basicConfig.vue?vue&type=script&lang=js&"
export * from "./basicConfig.vue?vue&type=script&lang=js&"
import style0 from "./basicConfig.vue?vue&type=style&index=0&id=a60b5cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60b5cf4",
  null
  
)

export default component.exports